export default __webpack_public_path__ + "static/media/marker.bbc60d91.svg";